export default __webpack_public_path__ + "static/media/Y1N1TSTMiig-HD.687e5ad7.jpg";